import {
  DeployStage,
  EventDispatcherOptions,
  Optimizely,
  Pulse,
} from "../typings";
import { errorToString } from "../utils";
import { v1EventBuilder } from "./v1EventBuilder";
import type { UserAttribute } from "../typings/optimizely";

export const createBatchedPulseEvents = (
  providerId: string,
  eventObj: Optimizely.EventObject,
  options: EventDispatcherOptions,
): Pulse.PulseEvent[] => {
  try {
    const { visitors } = eventObj.params;
    if (!visitors) return [];

    return visitors.map((visitor) => {
      const pulseEvent = visitorToPulseEvent(visitor, {
        deployStage: options.deployStage,
        providerId,
        userIdPrefix: options.userIdPrefix,
      });

      return options.eventModifier(pulseEvent);
    });
  } catch (error) {
    options.logger({
      type: "error",
      message: `[createBatchedPulseEvents] ${errorToString(error)}`,
    });
    return [];
  }
};

const visitorToPulseEvent = (
  visitor: Optimizely.Visitor,
  {
    deployStage,
    providerId,
    userIdPrefix,
  }: { deployStage: DeployStage; providerId: string; userIdPrefix: string },
): Pulse.PulseEvent => {
  const event = visitor.snapshots[0].events[0];
  const decision = visitor.snapshots[0].decisions?.[0];
  const { attributes = [] } = visitor;

  return v1EventBuilder({
    userAttributes: parseUserAttributes(attributes),
    campaignType: event.entity_id,
    deployStage,
    eventKey: event.key,
    eventTags: event.tags,
    experimentId: decision?.experiment_id,
    providerId,
    timestamp: event.timestamp,
    userIdPrefix,
    uuid: event.uuid,
    variant: decision?.metadata.variation_key,
    visitorId: visitor.visitor_id,
  });
};

const parseUserAttributes = (userAttributes: UserAttribute[]) => {
  const parsedAttrbutes: Record<string, string> = {};

  userAttributes.forEach(({ key, value }) => {
    parsedAttrbutes[key] = String(value);
  });

  return parsedAttrbutes;
};
